function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCoinOranum = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20.0004",
  ref: ref
}, props), /*#__PURE__*/React.createElement("g", {
  id: "fe2eb273-2339-42f7-909c-5e6e8a232e0a",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "bdf4cf86-5902-45e2-9f70-eed779fa6f12",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "b0e4fa2a-14b0-49c6-89fc-da7deb71494c",
  "data-name": "Fill-1",
  d: "M20,10.21A9.8968,9.8968,0,0,1,10,20,9.8972,9.8972,0,0,1,0,10.21a9.8973,9.8973,0,0,1,10-9.79A9.897,9.897,0,0,1,20,10.21",
  style: {
    fill: "#ff8d00",
    fillRule: "evenodd"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "b4eb77f4-c3d2-46bc-bf56-b430f2a378ac",
  "data-name": "Fill-4",
  d: "M20,9.7905A9.8969,9.8969,0,0,1,10,19.581a9.8972,9.8972,0,0,1-10-9.79A9.8972,9.8972,0,0,1,10,0,9.8969,9.8969,0,0,1,20,9.7905",
  style: {
    fill: "#fffa64",
    fillRule: "evenodd"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "e23a37a2-9a73-40f1-973b-c6468f7f5d01",
  "data-name": "Fill-7",
  d: "M19.6,9.7905a9.3006,9.3006,0,0,1-.1815,1.828,9.5171,9.5171,0,0,1-7.7615,7.431,9.8776,9.8776,0,0,1-3.92-.124,9.6234,9.6234,0,0,1-5.1995-3.225A9.2406,9.2406,0,0,1,.5716,8.0185,9.5481,9.5481,0,0,1,10,.392c.13,0,.261.002.39.0075a9.6563,9.6563,0,0,1,6.204,2.5615A9.2579,9.2579,0,0,1,19.6,9.7905",
  style: {
    fill: "#ffe500",
    fillRule: "evenodd"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "aed7ada9-5757-4646-a053-2ca67d2baf3b",
  "data-name": "Fill-9",
  d: "M19.6,9.7905a9.3006,9.3006,0,0,1-.1815,1.828L11.6571,19.05a9.8776,9.8776,0,0,1-3.92-.124c3.398-3.379,8.939-8.897,11.549-11.529A9.2662,9.2662,0,0,1,19.6,9.7905",
  style: {
    fill: "#fff85e",
    fillRule: "evenodd"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "f43ab718-24fc-4659-a6f9-86220aa73abd",
  "data-name": "Fill-11",
  d: "M16.594,2.9611,2.537,15.7006A9.2417,9.2417,0,0,1,.5715,8.0181L10.39.4a9.6551,9.6551,0,0,1,6.204,2.5614",
  style: {
    fill: "#fff85e",
    fillRule: "evenodd"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "f0a6eb9f-75a4-4517-a51f-d347898eb44c",
  "data-name": "Fill-13",
  d: "M17.6372,10.06A7.5581,7.5581,0,0,1,10,17.5375a7.6958,7.6958,0,0,1-5.387-2.178,7.3675,7.3675,0,0,1-2.25-5.2994A7.277,7.277,0,0,1,2.92,7.2545,7.6122,7.6122,0,0,1,8.8267,2.6711a7.756,7.756,0,0,1,6.9835,2.54,7.3337,7.3337,0,0,1,1.827,4.85",
  style: {
    fill: "#ffffb9",
    fillRule: "evenodd"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "e0101401-0a69-4c88-8521-2ac799e6a879",
  "data-name": "Fill-15",
  d: "M17.2939,10.06A7.2185,7.2185,0,0,1,10,17.201a7.35,7.35,0,0,1-5.1444-2.08A7.0364,7.0364,0,0,1,2.7064,10.06,6.9411,6.9411,0,0,1,3.2389,7.381,7.27,7.27,0,0,1,8.88,3.003a7.4086,7.4086,0,0,1,6.6694,2.4256,7.0029,7.0029,0,0,1,1.745,4.6315",
  style: {
    fill: "#ffb400",
    fillRule: "evenodd"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "b962f1b0-0cfa-4834-927f-ab7c778fe548",
  "data-name": "Fill-17",
  d: "M10,2.9187a7.2246,7.2246,0,0,1,7.2875,6.872c.0035-.09.007-.1795.007-.27A7.2194,7.2194,0,0,0,10,2.3792,7.219,7.219,0,0,0,2.706,9.5207c0,.0905.003.18.0065.27A7.2249,7.2249,0,0,1,10,2.9187",
  style: {
    fill: "#ff8d00",
    fillRule: "evenodd"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "a78810d9-40a1-4f11-a57c-90573b18a3ce",
  "data-name": "Fill-19",
  d: "M15.5491,5.4287,4.8551,15.1212a7.0388,7.0388,0,0,1-2.149-5.061,6.945,6.945,0,0,1,.5325-2.6795L8.88,3.0032a7.4076,7.4076,0,0,1,6.6695,2.4255",
  style: {
    fill: "#ffab00",
    fillRule: "evenodd"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "a6d29563-10b2-4e00-929e-41abf83d7049",
  "data-name": "Shadow",
  d: "M10.6625,14.35a5.7357,5.7357,0,0,0,2.6063-.5563,4.071,4.071,0,0,0,1.7125-1.575A4.6429,4.6429,0,0,0,15.5875,9.8a4.6344,4.6344,0,0,0-.6062-2.425,4.0839,4.0839,0,0,0-1.7125-1.5688A5.7357,5.7357,0,0,0,10.6625,5.25a5.7353,5.7353,0,0,0-2.6062.5562A4.03,4.03,0,0,0,6.35,7.3814,4.6814,4.6814,0,0,0,5.75,9.8a4.6726,4.6726,0,0,0,.6,2.4249,4.0415,4.0415,0,0,0,1.7062,1.5688A5.7353,5.7353,0,0,0,10.6625,14.35Zm0-.5251a2.4233,2.4233,0,0,1-1.5187-.4937A3.137,3.137,0,0,1,8.15,11.9377,5.89,5.89,0,0,1,7.8,9.8a5.8907,5.8907,0,0,1,.35-2.1376,3.137,3.137,0,0,1,.9937-1.3937,2.4233,2.4233,0,0,1,1.5187-.4938,2.4426,2.4426,0,0,1,1.5313.4938,3.0958,3.0958,0,0,1,.9875,1.3937A5.9883,5.9883,0,0,1,13.525,9.8a5.9877,5.9877,0,0,1-.3437,2.1375,3.0958,3.0958,0,0,1-.9875,1.3937A2.4426,2.4426,0,0,1,10.6625,13.8251Z",
  style: {
    fill: "#ff8d00"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "b5881799-bb92-46b7-b8f2-fee72e8fd47f",
  "data-name": "Front",
  d: "M10.0375,14.35a5.7357,5.7357,0,0,0,2.6063-.5563,4.071,4.071,0,0,0,1.7125-1.575A4.6429,4.6429,0,0,0,14.9625,9.8a4.6344,4.6344,0,0,0-.6062-2.425,4.0839,4.0839,0,0,0-1.7125-1.5688A5.7357,5.7357,0,0,0,10.0375,5.25a5.7353,5.7353,0,0,0-2.6062.5562,4.03,4.03,0,0,0-1.7062,1.575A4.68,4.68,0,0,0,5.125,9.8a4.6716,4.6716,0,0,0,.6,2.4249,4.0415,4.0415,0,0,0,1.7062,1.5688A5.7353,5.7353,0,0,0,10.0375,14.35Zm0-.5251a2.4233,2.4233,0,0,1-1.5187-.4937,3.137,3.137,0,0,1-.9937-1.3937A5.89,5.89,0,0,1,7.175,9.8a5.8907,5.8907,0,0,1,.35-2.1376,3.137,3.137,0,0,1,.9937-1.3937,2.4233,2.4233,0,0,1,1.5187-.4938,2.4426,2.4426,0,0,1,1.5313.4938,3.0958,3.0958,0,0,1,.9875,1.3937A5.9883,5.9883,0,0,1,12.9,9.8a5.9877,5.9877,0,0,1-.3437,2.1375,3.0958,3.0958,0,0,1-.9875,1.3937A2.4426,2.4426,0,0,1,10.0375,13.8251Z",
  style: {
    fill: "#ffe400"
  }
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCoinOranum);
export default ForwardRef;